export enum DocumentRequirement {
    NONE = 'NONE',
    OPTIONAL = 'OPTIONAL',
    MANDATORY = 'MANDATORY',
}

export interface LeaveTypeConfig {
    id: string;
    name: string;
    institutionId: string;
    documentRequirement: DocumentRequirement;
    isPaid?: boolean;
    isActive?: boolean;
}

export interface LeaveDocument {
    id: string;
    leaveApplicationId: string;
    originalFileName: string;
    contentType: string;
    fileSize: number;
}

export enum LeaveStatus {
    Pending = 'Pending',
    Approved = 'Approved',
    Rejected = 'Rejected',
    Cancelled = 'Cancelled'
}

export interface LeaveApplication {
    id: string;
    userId: string;
    userName: string | null;
    leaveType: string;
    leaveReason: string;
    applicationDate: string;
    startDate: string;
    endDate: string;
    leaveStatus: LeaveStatus;
    documents: LeaveDocument[];
    numberOfDays: number;
    actionedByName: string | null;
    actionedAt: string | null;
}

export interface LeaveApplicationResponse {
    content: LeaveApplication[];
    totalElements: number;
    totalPages: number;
    size: number;
    number: number;
}

export interface LeavePolicy {
    id: string;
    institutionId: string;
    leaveType: string;
    numberOfLeaves: number;
    isActive?: boolean;
}

export interface LeavePolicyCreate {
    institutionId: string;
    leaveType: string;
    numberOfLeaves: number;
}

export interface UserLeaveAllocation {
    id: string;
    institutionId: string;
    userId: string;
    userName: string;
    leaveType: string;
    numberOfLeaves: number;
    fiscalYear: number;
    isOverride: boolean;
}

export interface UserLeaveAllocationCreate {
    institutionId: string;
    userId: string;
    leaveType: string;
    numberOfLeaves: number;
    fiscalYear: number;
}

export interface LeaveBalance {
    userId: string;
    userName: string;
    leaveType: string;
    allocated: number;
    availed: number;
    remaining: number;
    isOverride: boolean;
}

export interface UserLeaveBalanceSummary {
    userId: string;
    userName: string;
    balances: LeaveBalance[];
}
